// settings.js
import EnhancedSettingsPage from './components/EnhancedSettingsPage.jsx';


// ✅ Export the component as default instead of the plain object
export default EnhancedSettingsPage;